module.exports = __webpack_public_path__ + "img/socialising-with-friends.19afd306.jpg";